"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.themes = exports.COLOR_LIST = exports.COLORS = exports.DARK_THEME = exports.DEFAULT_THEME = void 0;
const tslib_1 = require("tslib");
const base_1 = tslib_1.__importDefault(require("./base"));
const dark_1 = tslib_1.__importDefault(require("./dark"));
/**
 * The default theme to load
 */
exports.DEFAULT_THEME = "base";
exports.DARK_THEME = "dark";
exports.COLORS = {};
exports.COLOR_LIST = [
    "primary",
    "neutral",
    "storm-dust",
    "mecha-red",
    "leaf",
    "mecha-yellow",
    "tangerine",
    "grape",
    "theme-background",
    "header-white",
    "black",
    "white",
    "mecha-white",
    "mecha-border",
    "input-background",
    "mecha-shadow",
    "input-border",
    "transparent",
];
exports.themes = {
    default: base_1.default,
    dark: dark_1.default,
};
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiY29uZmlnLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vLi4vLi4vc3JjL3N0eWxlcy90aGVtZS9jb25maWcudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7OztBQUFBLDBEQUEwQjtBQUMxQiwwREFBMEI7QUFHMUI7O0dBRUc7QUFFVSxRQUFBLGFBQWEsR0FBRyxNQUFNLENBQUM7QUFDdkIsUUFBQSxVQUFVLEdBQUcsTUFBTSxDQUFDO0FBRXBCLFFBQUEsTUFBTSxHQUEyQixFQUFFLENBQUM7QUFDcEMsUUFBQSxVQUFVLEdBQW1CO0lBQ3hDLFNBQVM7SUFDVCxTQUFTO0lBQ1QsWUFBWTtJQUNaLFdBQVc7SUFDWCxNQUFNO0lBQ04sY0FBYztJQUNkLFdBQVc7SUFDWCxPQUFPO0lBQ1Asa0JBQWtCO0lBQ2xCLGNBQWM7SUFDZCxPQUFPO0lBQ1AsT0FBTztJQUNQLGFBQWE7SUFDYixjQUFjO0lBQ2Qsa0JBQWtCO0lBQ2xCLGNBQWM7SUFDZCxjQUFjO0lBQ2QsYUFBYTtDQUNkLENBQUM7QUFFVyxRQUFBLE1BQU0sR0FBRztJQUNwQixPQUFPLEVBQUUsY0FBSTtJQUNiLElBQUksRUFBSixjQUFJO0NBQ0wsQ0FBQyIsInNvdXJjZXNDb250ZW50IjpbImltcG9ydCBiYXNlIGZyb20gXCIuL2Jhc2VcIjtcbmltcG9ydCBkYXJrIGZyb20gXCIuL2RhcmtcIjtcbmltcG9ydCB7IElUaGVtZUNvbG9ycyB9IGZyb20gXCIuL3RoZW1lVHlwZXNcIjtcblxuLyoqXG4gKiBUaGUgZGVmYXVsdCB0aGVtZSB0byBsb2FkXG4gKi9cblxuZXhwb3J0IGNvbnN0IERFRkFVTFRfVEhFTUUgPSBcImJhc2VcIjtcbmV4cG9ydCBjb25zdCBEQVJLX1RIRU1FID0gXCJkYXJrXCI7XG5cbmV4cG9ydCBjb25zdCBDT0xPUlM6IFJlY29yZDxzdHJpbmcsIHN0cmluZz4gPSB7fTtcbmV4cG9ydCBjb25zdCBDT0xPUl9MSVNUOiBJVGhlbWVDb2xvcnNbXSA9IFtcbiAgXCJwcmltYXJ5XCIsXG4gIFwibmV1dHJhbFwiLFxuICBcInN0b3JtLWR1c3RcIixcbiAgXCJtZWNoYS1yZWRcIixcbiAgXCJsZWFmXCIsXG4gIFwibWVjaGEteWVsbG93XCIsXG4gIFwidGFuZ2VyaW5lXCIsXG4gIFwiZ3JhcGVcIixcbiAgXCJ0aGVtZS1iYWNrZ3JvdW5kXCIsXG4gIFwiaGVhZGVyLXdoaXRlXCIsXG4gIFwiYmxhY2tcIixcbiAgXCJ3aGl0ZVwiLFxuICBcIm1lY2hhLXdoaXRlXCIsXG4gIFwibWVjaGEtYm9yZGVyXCIsXG4gIFwiaW5wdXQtYmFja2dyb3VuZFwiLFxuICBcIm1lY2hhLXNoYWRvd1wiLFxuICBcImlucHV0LWJvcmRlclwiLFxuICBcInRyYW5zcGFyZW50XCIsXG5dO1xuXG5leHBvcnQgY29uc3QgdGhlbWVzID0ge1xuICBkZWZhdWx0OiBiYXNlLFxuICBkYXJrLFxufTtcbiJdfQ==